import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";

const TempoIcon = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 110 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Shadow */}
    <ellipse cx="55" cy="50" rx="45" ry="4" fill="white" opacity="0.15" />

    {/* Modern Delivery Cargo Truck - Facing Right */}
    {/* Cabin (Front on the right) */}
    <path
      d="M100 22 C100 22, 90 22, 86 22 C84 22, 82 24, 82 26 L82 42 L102 42 L102 28 C102 24, 100 22, 100 22 Z"
      fill="#dcfce7"
      stroke="white"
      strokeWidth="2"
    />
    {/* Windshield */}
    <path
      d="M98 24 L88 24 L86 29 L98 29 Z"
      fill="#14532d"
      opacity="0.8"
    />
    {/* Side Window */}
    <path
      d="M86 24 L83 24 L83 29 L85 29 Z"
      fill="#14532d"
      opacity="0.8"
    />
    {/* Bumper */}
    <rect x="100" y="38" width="6" height="4" rx="1.5" fill="#f8fafc" stroke="white" strokeWidth="1" />

    {/* Cargo Container (on the left) */}
    <rect
      x="14"
      y="14"
      width="68"
      height="26"
      rx="4"
      fill="#f8fafc"
      stroke="white"
      strokeWidth="2"
    />

    {/* Branding Lines/Design on Container */}
    <rect
      x="18"
      y="18"
      width="60"
      height="18"
      fill="#bbf7d0"
      opacity="0.9"
      rx="2.5"
    />

    {/* Vertical metallic structural lines */}
    <line x1="26" y1="18" x2="26" y2="36" stroke="white" strokeWidth="1.5" opacity="0.6" />
    <line x1="40" y1="18" x2="40" y2="36" stroke="white" strokeWidth="1.5" opacity="0.6" />
    <line x1="54" y1="18" x2="54" y2="36" stroke="white" strokeWidth="1.5" opacity="0.6" />
    <line x1="68" y1="18" x2="68" y2="36" stroke="white" strokeWidth="1.5" opacity="0.6" />

    {/* FRESH text in elegant font */}
    <text
      x="48"
      y="28"
      fontSize="6"
      fontWeight="900"
      fill="#14532d"
      textAnchor="middle"
      letterSpacing="1"
    >
      FRESH
    </text>

    {/* Front Wheel (on the right) */}
    <circle
      cx="90"
      cy="42"
      r="7"
      fill="#14532d"
      stroke="white"
      strokeWidth="1.5"
    />
    <circle cx="90" cy="42" r="3" fill="white" />
    <circle cx="90" cy="42" r="1.5" fill="#14532d" />

    {/* Back Wheels (on the left) */}
    <circle
      cx="34"
      cy="42"
      r="7"
      fill="#14532d"
      stroke="white"
      strokeWidth="1.5"
    />
    <circle cx="34" cy="42" r="3" fill="white" />
    <circle cx="34" cy="42" r="1.5" fill="#14532d" />

    <circle
      cx="22"
      cy="42"
      r="7"
      fill="#14532d"
      stroke="white"
      strokeWidth="1.5"
    />
    <circle cx="22" cy="42" r="3" fill="white" />
    <circle cx="22" cy="42" r="1.5" fill="#14532d" />
  </svg>
);

const ScooterIcon = ({ className = "" }) => (
  <svg
    className={className}
    style={{ transform: "scaleX(-1)" }}
    viewBox="0 0 90 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Shadow */}
    <ellipse cx="45" cy="50" rx="35" ry="4" fill="white" opacity="0.15" />

    {/* Frame */}
    <path
      d="M18 38h50"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <line
      x1="30"
      y1="38"
      x2="30"
      y2="18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="30"
      y1="22"
      x2="50"
      y2="28"
      stroke="white"
      strokeWidth="1.5"
      opacity="0.7"
    />

    {/* Delivery Box - Modern Design */}
    <defs>
      <linearGradient id="boxGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style={{ stopColor: "#dcfce7", stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#bbf7d0", stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <rect
      x="48"
      y="12"
      width="28"
      height="20"
      rx="3"
      fill="url(#boxGradient)"
      stroke="white"
      strokeWidth="2"
    />

    {/* Box Stripes/Branding */}
    <rect
      x="50"
      y="14"
      width="24"
      height="3"
      fill="white"
      rx="1"
      opacity="0.8"
    />
    <circle cx="62" cy="22" r="4" fill="white" opacity="0.6" />

    {/* Seat */}
    <ellipse
      cx="38"
      cy="35"
      rx="7"
      ry="4"
      fill="#f8fafc"
      stroke="white"
      strokeWidth="1.5"
    />
    <path d="M32 35h12" stroke="white" strokeWidth="1" opacity="0.5" />

    {/* Handlebars */}
    <path d="M30 18v6" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    <path
      d="M24 16c0-3 6-4 6-4s6 1 6 4"
      fill="none"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="30" cy="16" r="3" fill="#bbf7d0" />

    {/* Front Wheel */}
    <circle
      cx="18"
      cy="40"
      r="7"
      fill="#14532d"
      stroke="white"
      strokeWidth="1.5"
    />
    <circle cx="18" cy="40" r="3.5" fill="white" />
    <circle cx="18" cy="40" r="1.5" fill="#14532d" />

    {/* Back Wheel */}
    <circle
      cx="62"
      cy="40"
      r="7"
      fill="#14532d"
      stroke="white"
      strokeWidth="1.5"
    />
    <circle cx="62" cy="40" r="3.5" fill="white" />
    <circle cx="62" cy="40" r="1.5" fill="#14532d" />

    {/* Spokes - Front */}
    <line
      x1="18"
      y1="33"
      x2="18"
      y2="47"
      stroke="white"
      strokeWidth="0.8"
      opacity="0.4"
    />
    <line
      x1="11"
      y1="40"
      x2="25"
      y2="40"
      stroke="white"
      strokeWidth="0.8"
      opacity="0.4"
    />

    {/* Engine detail */}
    <rect x="34" y="32" width="3" height="2" fill="#bbf7d0" rx="1" />
  </svg>
);

const HeaderStrip = () => {
  const navigate = useNavigate();
  const stripRef = useRef(null);
  const tempoRef = useRef(null);
  const scooterRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      stripRef.current,
      { y: -36, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.55, ease: "power3.out" },
    );
  }, []);

  useEffect(() => {
    const el = tempoRef.current;
    if (!el) return undefined;

    const strip = stripRef.current;
    const width = strip ? strip.offsetWidth : window.innerWidth;

    gsap.set(el, { x: -120 });
    const tween = gsap.to(el, {
      x: width + 40,
      duration: 10,
      ease: "none",
      repeat: -1,
      repeatDelay: 2,
    });

    return () => tween.kill();
  }, []);

  useEffect(() => {
    const el = scooterRef.current;
    if (!el) return undefined;

    const strip = stripRef.current;
    const width = strip ? strip.offsetWidth : window.innerWidth;

    gsap.set(el, { x: -120 });
    const tween = gsap.to(el, {
      x: width + 40,
      duration: 10,
      ease: "none",
      repeat: -1,
      repeatDelay: 4,
      delay: 4,
    });

    return () => tween.kill();
  }, []);

  return (
    <div
      ref={stripRef}
      className="relative hidden overflow-hidden bg-gradient-to-r from-primary-600 to-primary-700 text-white sm:block"
    >
      <div
        ref={tempoRef}
        className="pointer-events-none absolute top-1/2 -translate-y-1/2"
        style={{ zIndex: 2 }}
      >
        <TempoIcon className="h-9 w-20 drop-shadow-md" />
      </div>

      <div
        ref={scooterRef}
        className="pointer-events-none absolute top-1/2 -translate-y-1/2"
        style={{ zIndex: 2 }}
      >
        <ScooterIcon className="h-8 w-16 drop-shadow-md" />
      </div>

      {/* Narrowed container */}
      <div className="relative z-10 mx-auto max-w-5xl px-4 py-1">
        <div className="flex items-stretch gap-0 overflow-hidden rounded-lg">

          {/* ── Left Section: Announcement ── */}
          <div className="flex flex-1 items-center justify-center gap-2 bg-white/10 px-4 py-1.5">
            <span className="text-[10px] font-black uppercase tracking-widest text-white/60">
              🔔 Notice
            </span>
            <span className="h-3 w-px bg-white/30" />
            <p className="text-xs font-semibold text-white/90">
              Welcome to KKISANFRESH — 🚧 Website Under Development
            </p>
          </div>

          {/* Divider */}
          <div className="w-px bg-white/20" />

          {/* ── Right Section: Track Order ── */}
          <div className="flex shrink-0 items-center bg-white/5 px-4 py-1.5">
            <button
              onClick={() => navigate("/account/track")}
              className="flex items-center gap-1.5 rounded-full border border-white/30 bg-white/10 px-3 py-1 text-xs font-bold text-white transition-all hover:bg-white/20 active:scale-95"
            >
              <svg
                className="h-3.5 w-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                />
              </svg>
              <span className="hidden sm:inline">Track Order</span>
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HeaderStrip;
